import React, { useState, createContext, useEffect, useContext } from 'react';
import axios from '../Util/axiosConfig';
import { baseUrl } from '../Contants';
import { AppContext } from './AppContextProvide';
import { HubSpokeContext } from './HubSpokeContextProvider';

export const ProductStatsContext = createContext();

export const ProductStatsContextProvider = ({ children, lazy = false }) => {
  const { user } = useContext(AppContext);
  const { selectedSpoke } = useContext(HubSpokeContext);
  const [productStats, setProductStats] = useState([]);
  const [days, setDays] = useState(30);
  const [productLikes, setProductLikes] = useState([]);
  const [productCheckouts, setProductCheckouts] = useState([]);
  const [productStatCards, setProductStatCards] = useState([]);

  const isLoggedIn = user.user_id;

  useEffect(() => {
    async function getProductLikes() {
      const result = await axios(
        `${baseUrl}/api/stats/products/likes/?siteName=${selectedSpoke}`
      );
      setProductLikes(result.data.data);
    }

    async function getProductCheckouts() {
      const result = await axios(
        `${baseUrl}/api/stats/products/checkouts?siteName=${selectedSpoke}`
      );
      setProductCheckouts(result.data.data);
    }

    async function getProductsStats() {
      const result = await axios(
        `${baseUrl}/api/stats/products?days=${days}&siteName=${selectedSpoke}`
      );
      setProductStats(result.data.data);
    }

    // In lazy mode (e.g. the product page, where only `days` is consumed by the
    // stats dialog) skip the eager likes/checkouts/products fetches — they are
    // ~25KB of dashboard-weight queries the page never reads.
    if (isLoggedIn && !lazy) {
      getProductsStats();
      getProductLikes();
      getProductCheckouts();
    }
  }, [isLoggedIn, days, selectedSpoke, lazy]);

  return (
    <ProductStatsContext.Provider
      value={{ productStats, productLikes, productCheckouts, days, setDays }}
    >
      {children}
    </ProductStatsContext.Provider>
  );
};
